/** General access levels, as the dialog's `privacy` state holds them. */
export const ACCESS_ANYONE = 0;
export const ACCESS_RESTRICTED = 1;

/** The dialog's two views: general access, or inviting people (restricted). */
export const ACCESS_VIEW = 'access';
export const INVITE_VIEW = 'invite';
